import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { Static } from 'core-components/types'
import { MarketApi } from 'core/classes/services/api/MarketApi'
import { CrudStoreItemCore } from 'core/classes/services/InitializationServiceCore'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { THPRoles } from '../../../model/forms'
import { IContact } from '../../../model/types'
import { filterHPRoles } from '../helpers'

const initCrud = new Crud({
  fetcher: new Static<THPRoles>([]),
  keyField: 'title',
})

export const useHPRolesSource = (contact: Pick<IContact, 'region' | 'market'>) => {
  const { roleIds } = useSelector(selectUser)
  const [source, setSource] = useState<Crud<THPRoles>>(initCrud)

  const hpRolesSource = useMemo(() => {
    const crud = CrudStore.get(CrudStoreItemCore.Dropdowns, 'HPRoles')
    crud.setRoot('HPRoleDropdown')
    crud.setSort([{ field: 'en', dir: 'asc' }])
    return crud
  }, [])

  const isAOM = useMemo(() => {
    return roleIds.includes('AOM')
  }, [roleIds])

  const isPBM = useMemo(() => {
    return roleIds.includes('PBM')
  }, [roleIds])

  const region = useMemo(() => {
    if (!contact.region) {
      return MarketApi.getRegion(contact.market).Region
    }
    return contact.region
  }, [contact.region, contact.market])

  useEffect(() => {
    hpRolesSource.fetch().then((data) => {
      if (data) {
        const roles = data.items.map<THPRoles>((el) => ({
          key: el.EntryId,
          title: el.value,
          region: el.Relation,
        }))
        const filteredRoles = roles.filter((el) => filterHPRoles(el, { isAOM, isPBM, region }))
        setSource(
          new Crud({
            fetcher: new Static(filteredRoles),
            keyField: 'title',
            defaultPaging: {
              page: 0,
              pageSize: 30,
            },
          })
        )
      }
    })
  }, [hpRolesSource, isAOM, isPBM, region])

  return source
}
